import { render, staticRenderFns } from "./privacyJk.vue?vue&type=template&id=25c6fab8&scoped=true"
import script from "./privacyJk.vue?vue&type=script&lang=js"
export * from "./privacyJk.vue?vue&type=script&lang=js"
import style0 from "./privacyJk.vue?vue&type=style&index=0&id=25c6fab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c6fab8",
  null
  
)

export default component.exports